import React from 'react';

import routes from 'js/core_pre_webpack/routes';
import Unibrow from 'js/design_system/Unibrow';
import InfoIcon from 'js/design_system/icons/info.svg';

export default function AddSecondaryPaymentUnibrow() {
  const dismissibleName = 'AddSecondaryPaymentUnibrow';

  const handleClick = () => {
    // settings_url (vs settings_path) forces the www subdomain.
    window.location.href = routes.settings_url({
      anchor: 'premium-subscription',
      feature: 'add_secondary_payment_unibrow',
      trigger: 'unibrow',
    });
  };

  return (
    <Unibrow
      variant="beige"
      dismissibleName={dismissibleName}
      text="Please add a secondary payment method to prevent interruption of your subscription."
      primaryButton={{
        text: 'Add Payment Method',
        onClick: handleClick,
        trackClick: {
          source: 'add_secondary_payment_unibrow',
        },
      }}
      icon={<InfoIcon />}
    />
  );
}
